<template>
    <textarea ref="input" :id="_id" :name="name" v-model="input" :required="_required" v-bind="Object.assign({}, $attrs, ariaValidationAttributes)"></textarea>
</template>

<script lang="ts">
    import {Component, Prop, Watch} from 'vue-facing-decorator';
    import {AbstractFormInput} from '../../mixins/AbstractFormInput';

    @Component({
        name: 'FormTextarea',
        emits: ['update:modelValue'],
    })
    export default class FormTextarea extends AbstractFormInput
    {
        readonly $refs: { input: HTMLTextAreaElement };

        @Prop({
            type: String,
            default: '',
            required: false,
        }) modelValue: string;

        type = 'text'; // unused?

        input = this.modelValue;

        timeout: number = 0;

        @Watch('input')
        watchInput(newValue: string)
        {
            this.$emit('update:modelValue', newValue);
        }

        @Watch('modelValue')
        watchValue(newValue: string, oldValue: string)
        {
            // 'fake' debounce
            if (this.timeout)
            {
                clearTimeout(this.timeout);
            }

            this.timeout = window.setTimeout(() =>
            {
                this.input = newValue;

                if (newValue !== oldValue)
                {
                    this.$nextTick(this.updateValue);
                }
            }, 200);
        }

        updateValue()
        {
            let input = this.input;

            if (this.$refs.input)
            {
                input = this.$refs.input.value;
            }

            return this.validateValue(input);
        }
    }
</script>